import React from 'react';
import Button from '@material-ui/core/Button';
import styles from '../../constants/KobooRoundButton.css';

const KobooButton = (props) => {
  let buttonStyle = { ...styles.round };
  if (props.width) {
    buttonStyle.width = props.width;
  }
  if (props.style) {
    buttonStyle = {...buttonStyle, ...props.style};
  }
  return (
    <Button
      variant="contained"
      color="primary"
      {...props}
      style={buttonStyle}
    />
  );
}

export default KobooButton;



// WEBPACK FOOTER //
// ./src/components/Layout/KobooButton.jsx